import type { IconData } from '@stacksjs/iconify-core'

export const shoppingBox: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M0 1h5v6l3-3l3 3V1h5v14H0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default shoppingBox
